import { createContext, useContext } from 'react';
export const ModalsContext = /*#__PURE__*/createContext({
  setModal: null
});
export const useModalsContext = () => {
  let context = ModalsContext;
  if (typeof window !== 'undefined' && window['@ui5/webcomponents-react']?.ModalsContext) {
    context = window['@ui5/webcomponents-react'].ModalsContext;
  }
  return useContext(context);
};